export default "__VITE_ASSET__BzhY$$tr__"